import script from "./IntermediaryPeopleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./IntermediaryPeopleDetail.vue?vue&type=script&setup=true&lang=js"

import "./IntermediaryPeopleDetail.vue?vue&type=style&index=0&id=45c84f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c84f32"]])

export default __exports__